import React, { useState } from "react";
import style from "./Navbar.module.css";
import logo from "../../Assets/logoLaw.png";

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className={style.navbar}>
      <div className={style.content}>
        <img src={logo} alt="logo" className={style.logo} />
        <button className={style.menuButton} onClick={toggleMenu} aria-label="Menu">
          <span className={style.menuIcon}></span>
          <span className={style.menuIcon}></span>
          <span className={style.menuIcon}></span>
        </button>
        <div className={`${style.linkConteiner} ${menuOpen ? style.menuOpen : ''}`}>
          <a href="#about" className={style.link} onClick={closeMenu}>
              Inicio{" "}
            </a>
          <a href="#espacios" className={style.link} onClick={closeMenu}>
              Espacios{" "}
            </a>
            <a href="#planes" className={style.link} onClick={closeMenu}>
              Planes{" "}
            </a>
            <a href="#servicios" className={style.link} onClick={closeMenu}>
              Servicios{" "}
            </a>
            <a href="#contacto" className={style.link} onClick={closeMenu}>
              Contacto{" "}
            </a>
        </div>
      </div>
    </div>
  );
};
